import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ControlLabel, FormControl } from 'react-bootstrap';
import { Control, LocalForm } from 'react-redux-form';
import CloudAcquisitionTableComponent from '../Components/CloudAcquisitionTableComponent';

export default class CloudAcquisitionTopicBuildComponent extends Component {
  static propTypes = {
    acquisitions: PropTypes.array,
    buildNumber: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  render() {
    const {
      buildNumber,
      acquisitions,
      onChange
    } = this.props;

    const initialState = { buildNumber : buildNumber };
    return (
      <LocalForm
        id="topic-build-number-form"
        initialState={initialState}
        onChange = {onChange}
      >
        <Row>
          <Col xs={2} sm={2} md={2} style={{ minWidth : '200px', textAlign : 'center' }}>
            <ControlLabel style={{ marginTop : '10px' }}>
              Enter a build number
            </ControlLabel>
            <Control.custom
              style={{ marginBottom : '10px' }}
              id="topic-build-number-input"
              className="topicSelector"
              type="number"
              model="."
              component={FormControl}
              mapProps={() => {
                return {
                  value: this.props.buildNumber,
                  onChange: this.props.onChange()
                };
              }}
            />
          </Col>
          <Col>
            <CloudAcquisitionTableComponent acquisitions = {acquisitions} />
          </Col>
        </Row>
      </LocalForm>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/CloudAcquisitionTopicBuildComponent.jsx